export default {"src":"/_next/static/media/GS-Icon-Location-White.a6cf3676.svg","height":14,"width":14,"blurWidth":0,"blurHeight":0};